export default __webpack_public_path__ + "static/media/lorient6.7fb0ee93.jpg";